import { getCompareParams } from "../../../Components/Filters/CompareSelect/presets"
import { getDates } from "../../../Utils/utils"
import { withCurrentPreset } from "./period"

const joinTags = (tags) => (Array.isArray(tags) && tags.length ? tags.join(",") : null)

// The query every card of the page sends, in the parameters the backend reads
// (consumer_clarity/filters/admin_analytics.py, serializers/admin_analytics.py).
// `userEmails` and `testData` are the admin panel's global filters.
export const toAdminDeflectQuery = (storedFilters, userEmails, testData) => {
  const filters = withCurrentPreset(storedFilters)
  const dates = getDates(filters.period)
  const hasDates = Boolean(dates.start_date && dates.end_date)
  const isEmailHidden = filters.exclude_fields?.includes("user_email")

  const query = {
    test_data: testData,
    program: filters.program === "all" ? null : filters.program,
    channels: filters.channels === "all" ? null : joinTags(filters.channels),
    [isEmailHidden ? "exclude_user_email" : "user_email"]: joinTags(userEmails),
    user_full_name: joinTags(filters.user_full_name),
    business_account: joinTags(filters.business_account),
    // All time sends no dates and has no comparison (DAA-2-17).
    ...(hasDates ? { ...dates, ...getCompareParams(filters.compare, dates) } : {})
  }

  // An unset filter is not sent at all.
  return Object.fromEntries(Object.entries(query).filter(([, value]) => value != null))
}
